export default __webpack_public_path__ + "static/media/BMWColorSensitive.c869c6ca.png";